import { api } from "../../../utility/AxiosInceptor";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addRolesAction = createAsyncThunk("addroles", async (body) => {
  try {
    const response = await api.post(`/api/web/role`, body);

    return response.data;
  } catch (error) {
    throw error;
  }
});
